import React from 'react'
import { AppSvg, Dropdown, FormattedHTMLMessage, newIcons } from '@web/walter-ui-kit'
import { Placement } from '@floating-ui/react'

import cn from 'classnames'
import { lang } from './lang'
import QuickMenu from './Menu'
import s from './s.module.css'
import { useIsReceiveDisabled } from '~hooks/actions/useIsReceiveDisabled'
import { useIsSwapDisabled } from '~hooks/actions/useIsSwapDisabled'

interface Props {
    currency?: string
    amount?: string
    placement?: Placement
}

function AddFunds({ currency, placement = 'bottom-start' }: Props) {
    const receiveLogic = useIsReceiveDisabled(currency)
    const swapLogic = useIsSwapDisabled(currency)

    if (swapLogic.isDisabled && receiveLogic.isDisabled) {
        return null
    }

    return (
        <div data-pointer="add_funds">
            <Dropdown
                showShadow
                dataPointer="dropdown_add_fund"
                placement={placement}
                content={
                    <QuickMenu
                        currency={currency}
                        showSwap={!swapLogic?.isDisabled}
                        showReceive={!receiveLogic?.isDisabled}
                    />
                }
            >
                {open => (
                    <div className={s.addFund}>
                        <FormattedHTMLMessage {...lang.addFund} />
                        <AppSvg
                            path="new-icons"
                            className={cn(open && s.chevron)}
                            svgName={newIcons.ic24ChevronDown}
                            size={16}
                        />
                    </div>
                )}
            </Dropdown>
        </div>
    )
}

export default AddFunds
